import type { User } from "types/UserZendesk";
import { formatCNPJ, formateCpf, formatPhone } from "@hooks/masks";

export function UserData(selectedUser: User | null) {
    const { cpf_3, cnpj_regex } = selectedUser?.user_fields ?? {};

    const getDocumentInfo = () => {
        const label = cpf_3?.length === 11 ? 'CPF' : cnpj_regex ? 'CNPJ' : 'Documento';
        const value = cpf_3?.length === 11 ? formateCpf(cpf_3) : cnpj_regex ? formatCNPJ(cnpj_regex) : '—';
        return { label, value };
    };

    const getPhoneInfo = () => ({
        label: "Número",
        value: formatPhone(selectedUser?.phone ?? '')
    });

    const getEmailInfo = () => ({
        label: "E-mail",
        value: (
            <a href={`mailto:${selectedUser?.email}`} className="text-blue-600 underline">
                {selectedUser?.email}
            </a>
        )
    });

    const getNameInfo = () => ({
        label: "Nome",
        value: selectedUser?.name
    });

    return { getDocumentInfo, getPhoneInfo, getEmailInfo, getNameInfo };
}